var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { plainToClass } from 'class-transformer';
import Model from 'models/Model';
import Image from './Image';
var Album = /** @class */ (function (_super) {
    __extends(Album, _super);
    function Album() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Album.prototype.getId = function () {
        return Number(this.id);
    };
    Album.prototype.getName = function () {
        return this.name;
    };
    Album.prototype.getImage = function () {
        var image = this.images.slice(-1)[0];
        return image ? plainToClass(Image, image) : undefined;
    };
    Album.prototype.getImages = function () {
        return plainToClass(Image, this.images);
    };
    return Album;
}(Model));
export default Album;
